import React from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";

const ProfileLinks = ({ userDetails, handleChange }) => {
  return (
    <>
      <Row className="mb-3">
        <Col sm={4} xs={12}>
          <Label>Facebook URL: </Label>
          <Input
            type="text"
            name="facebookUrl"
            value={userDetails?.facebookUrl}
            onChange={handleChange}
          />
        </Col>
        <Col sm={4} xs={12}>
          <Label>Instagram URL: </Label>
          <Input
            type="text"
            name="instagramUrl"
            value={userDetails?.instagramUrl}
            onChange={handleChange}
          />
        </Col>
        <Col sm={4} xs={12}>
          <Label>Yelp URL: </Label>
          <Input
            type="text"
            name="yelpUrl"
            value={userDetails?.yelpUrl}
            onChange={handleChange}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={4} xs={12}>
          <Label>Website Link 1 </Label>
          <Input
            type="text"
            name="websiteLinkOne"
            value={userDetails?.websiteLinkOne}
            onChange={handleChange}
          />
        </Col>
        <Col sm={4} xs={12}>
          <Label>Website Link 2 </Label>
          <Input
            type="text"
            name="websiteLinkTwo"
            value={userDetails?.websiteLinkTwo}
            onChange={handleChange}
          />
        </Col>
        <Col sm={4} xs={12}>
          <Label>Website Link 3</Label>
          <Input
            type="text"
            name="websiteLinkThree"
            value={userDetails?.websiteLinkThree}
            onChange={handleChange}
          />
        </Col>
      </Row>
      <FormGroup>
        <Label>Bio</Label>
        <Input
          type="textarea"
          name="BioData"
          value={userDetails.BioData}
          onChange={handleChange}
        />
      </FormGroup>
    </>
  );
};

export default ProfileLinks;
